export default "__VITE_ASSET__TUp3D9qV__"